import { ReactNode } from "react";

type TopicHeaderProps = {
  icon: ReactNode;
  title: string;
  descriptionHtml: string;
};

const TopicHeader = ({ icon, title, descriptionHtml }: TopicHeaderProps) => {
  return (
    <>
      <div className="flex items-center gap-3">
        {icon}
        <h1 className="text-2xl font-bold">{title}</h1>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        className="ql-editor mt-2"
      />
    </>
  );
};

export default TopicHeader;
